export const DEVICE_HISTORY_MAX_TO_SHOW = 5
